import React, { Fragment } from 'react'
import { ClientDetailedDto } from 'api/Clients/Types/ClientDetailedDto'
import { UpdateClientStatus } from 'api/Clients/Types/UpdateClientStatus'
import { Spinner } from 'components/Spinner'
import TransactionOverviewForWalletOrClient from 'routes/Transactions/Details/TransactionsOverviewForWalletOrClient/TransactionOverviewForWalletOrClientTable'

import { ClientNavigation, ClientTab } from '../../Navigation/ClientNavigation'

interface Props {
  data: ClientDetailedDto

  forceRefresh(): void
  updateClientStatus(values: UpdateClientStatus): void
}

const ClientDetailsTransactionsPage: React.FC<Props> = ({ data, updateClientStatus }) => {
  if (!data) {
    return <Spinner />
  }

  return (
    <Fragment>
      <ClientNavigation
        isEdit={false}
        data={data}
        tab={ClientTab.TRANSACTIONS}
        updateClientStatus={updateClientStatus}
      />
      <TransactionOverviewForWalletOrClient clientId={data.id} />
    </Fragment>
  )
}

export default ClientDetailsTransactionsPage
